import React from 'react';

// ---------- utils ----------
const findRx = (files, rx) => files.find(f => rx.test(f?.name || ''));

const base64DataURI = (b64, mime = 'application/octet-stream') =>
  `data:${mime};base64,${(b64 || '').trim()}`;

// ---------- special renderers ----------
const CircosRenderer = ({ section }) => {
  if (!section.htmlFile) return null;

  const htmlContent = section.htmlFile.data || '';
  const srcDoc = htmlContent.startsWith('data:')
    ? atob(htmlContent.split(',')[1])
    : htmlContent;

  return (
    <div className="WSNG-circos-panel">
      <iframe
        srcDoc={srcDoc}
        title="Circos Visualization"
        style={{
          width: '100%',
          height: '800px',
          border: 'none',
          borderRadius: '8px',
          backgroundColor: '#fff'
        }}
      />
    </div>
  );
};

// ---------- organizer (multi-sv-cnv) ----------
export const organizeMultiSvCnv = (files, jobData) => {
  const findData = (rx) => findRx(files, rx)?.data || '';

  // --- 1. CNV Table ---
  const cnvTableData = findData(/\.cnv\.annotated\.tsv$/i);
  const cnvTables = cnvTableData ? [
    { name: 'CNV Annotations', data: cnvTableData, active: true }
  ] : [];

  const cnvOverview = cnvTables.length ? { tables: cnvTables } : undefined;

  // --- 2. Circos Visualization ---
  const circosHtml = findRx(files, /_vcf2circos\.html$/i);
  const circos = circosHtml ? {
    htmlFile: circosHtml,
    tables: []
  } : undefined;

  // --- 3. VCF Files (Additional Data) ---
  const vcfFiles = [
    { name: 'Annotated TSV', data: findData(/input\.annotated\.tsv$/i) },
  ]
  .filter(t => t.data)
  .map((t, i) => ({ ...t, active: i === 0 }));

  const vcfData = vcfFiles.length ? { tables: vcfFiles } : undefined;

  // --- Assemble All Tabs ---
  const organized = {
    ...(cnvOverview ? { 'CNV Table': cnvOverview } : {}),
    ...(circos ? { 'Circos Figure': circos } : {}),
    ...(vcfData ? { 'VCF Files': vcfData } : {}),
  };

  const renderers = {
    'Circos Figure': (props) => <CircosRenderer {...props} />,
  };

  const firstTab = cnvOverview ? 'CNV Table' : (circos ? 'Circos Figure' : 'VCF Files');
  const initial = {
    tab: firstTab,
    sub: (cnvTables[0] || {}).name
  };

  return { organized, renderers, initial };
};
